import React from 'react'

import { useRouteMatch } from 'react-router-dom'

import {
  Typography,
  makeStyles,
  AppBar,
  useScrollTrigger,
  Toolbar,
} from '@material-ui/core'

import { routes } from 'routes'
import { SafeEnvironment } from 'components'
import CartButton from './../CartButton'
import useSubscribe from 'hooks/useSubscribe'
import styles from './styles'

const useStyles = makeStyles(styles)

const ElevationScroll = props => {
  const { children, window } = props

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  })
}

const Topbar = () => {
  const subscribe = useSubscribe()
  const classes = useStyles()
  const matchRouteSubscribeMain = useRouteMatch(routes.subscribe.main)

  const isRouteSubscribeMain = React.useMemo(
    () => matchRouteSubscribeMain && matchRouteSubscribeMain.isExact,
    [matchRouteSubscribeMain],
  )

  return (
    <>
      <ElevationScroll>
        <AppBar position="sticky" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <Typography
              variant="h1"
              color="textSecondary"
              className={classes.seller}
            >
              {subscribe.seller &&
                (subscribe.seller.tradeName || subscribe.seller.name)}
            </Typography>

            {isRouteSubscribeMain && <CartButton />}
            {!isRouteSubscribeMain && (
              <SafeEnvironment className={classes.safeEnvironment} />
            )}
          </Toolbar>
        </AppBar>
      </ElevationScroll>
    </>
  )
}

export default Topbar
